import PropTypes from "prop-types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Chip from "core/components/Chip/Chip";
import styled from "styled-components";
import { dh_colors } from "theme";

const LegendChipContainer = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 4px;

  svg {
    cursor: default;
    pointer-events: none;
  }

  ${(props) =>
    props.intent === "negative" &&
    `
    background-color: ${dh_colors.salmon_70};
    color: ${dh_colors.white};

    svg {
        color: ${dh_colors.white};
    }
`}

  ${(props) =>
    props.intent === "positive" &&
    `
    background-color: ${dh_colors.green_50};
    color: ${dh_colors.white};

    svg {
        color: ${dh_colors.white};
    }

  `}

  ${(props) =>
    props.intent === "unmodified" &&
    `
    background-color: ${dh_colors.white};
    color: ${dh_colors.black};

    svg {
        color: ${dh_colors.black};
    }

  `}

    ${(props) =>
    props.intent === "modified" &&
    `
    background-color:  ${dh_colors.blue_60};
    color: ${dh_colors.white};

    svg {
        color: ${dh_colors.white};
    }

  `}

  ${(props) =>
    props.rightIcon &&
    `
    height: fit-content;
    width: fit-content;
    padding: 2px 6px;
    border-radius: 4px;
    gap: 5px;

    `}
`;

const LegendIcon = styled.span`
  display: inline-flex;
  align-items: center;

  svg {
    width: 14px;
    height: 14px;
  }
`;

const legendIntentStyles = {
  positive: {
    backgroundColor: dh_colors.green_50,
    color: dh_colors.white,
  },
  negative: {
    backgroundColor: dh_colors.salmon_70,
    color: dh_colors.white,
  },
  modified: {
    backgroundColor: dh_colors.blue_60,
    color: dh_colors.white,
  },
  unmodified: {
    backgroundColor: dh_colors.white,
    color: dh_colors.black,
    border: `1px solid ${dh_colors.grey_60}`,
  },
};

export const LegendChip = ({
  text,
  intent = "unmodified",
  rightIcon,
  tabIndex,
  isDisabled,
  style,
}) => {
  const intentStyle = legendIntentStyles[intent] ?? {};

  return (
    <LegendChipContainer
      intent={intent}
      rightIcon={rightIcon}
      style={{ ...style }}
    >
      <Chip
        text={text}
        variant="default"
        size="small"
        tabIndex={tabIndex}
        isDisabled={isDisabled}
        style={{ ...intentStyle }}
      />

      {rightIcon && (
        <LegendIcon intent={intent}>
          <FontAwesomeIcon icon={rightIcon} />
        </LegendIcon>
      )}
    </LegendChipContainer>
  );
};

LegendChip.propTypes = {
  intent: PropTypes.oneOf(["positive", "negative", "modified", "unmodified"]),
  isDisabled: PropTypes.any,
  rightIcon: PropTypes.any,
  style: PropTypes.any,
  tabIndex: PropTypes.any,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
